import { clsx } from 'clsx';
import { Alert } from '@material-ui/lab';

import { OrderDetailWhim } from '../order-detail-whim';
import { OrderProductsByCorridor } from '../order-products-by-corridor';
import { OrderDetailDisclaimer } from 'components/order-management/shared';
import {
  SubstitutionFlowStatusChip,
  SUBSTITUTION_FLOW_STATUS_MAP,
  SubstitutionFlowStatusAlert,
} from 'features/order/substitution-flow';
import { ForceOrderInvoicePrinting } from 'features/print-management/order-invoice-printing';
import { ReactComponent as BagOutlineIcon } from 'assets/images/icons/BagOutlineIcon.svg';

import { useOrderDetailDialogProductsSection } from './useOrderDetailDialogProductsSection';

import makeClasses from './OrderDetailDialogProductsSection.styles';

function OrderDetailDialogProductsSection({
  orderDetailDescription,
  totalUnitsProductsText,
  orderManagement,
  hasOrderManagement,
  classes = {},
}) {
  const {
    lang,
    orderId,
    substitutionFlowState,
    productsByCorridor,
    whims,
    isBeingManaged,
    isAuditable,
  } = useOrderDetailDialogProductsSection();

  const _classes = makeClasses();
  const _HIDE_OM = true;

  return (
    <div className={clsx(_classes.root, classes?.root)}>
      <div
        className={clsx(
          _classes.productsByCorridorContainer,
          classes?.productsByCorridorContainer,
        )}
      >
        <div className={_classes.orderDetailSection}>
          <div className={_classes.orderInfo}>
            <h2>{orderDetailDescription}</h2>
            <div className={_classes.orderInfoDetail}>
              <span>{totalUnitsProductsText}</span>
              <SubstitutionFlowStatusChip
                status={substitutionFlowState?.status}
                deletedAt={substitutionFlowState?.deletedAt}
              />
            </div>
          </div>
          <SubstitutionFlowStatusAlert orderId={orderId} />
          {isAuditable && (
            <Alert
              severity='error'
              variant='filled'
              icon={<BagOutlineIcon fill='inherit' />}
              className={_classes.auditBanner}
            >
              <div dangerouslySetInnerHTML={{ __html: lang.auditable }} />
            </Alert>
          )}
          {hasOrderManagement && !_HIDE_OM && (
            <OrderDetailDisclaimer order={orderManagement} isInProductSection />
          )}
        </div>
        <OrderProductsByCorridor
          classes={{ root: _classes.root, corridor: _classes.corridorName }}
          orderId={orderId}
          isBeingManaged={isBeingManaged}
        />
        {whims.map((whim, index) => (
          <OrderDetailWhim
            key={`whim-${whim.id}-${index}`}
            id={whim.id}
            name={whim.name}
            price={whim.price}
            showDeleteBtn={isBeingManaged}
          />
        ))}
      </div>

      <ForceOrderInvoicePrinting orderIdForced={orderId} />
    </div>
  );
}

export default OrderDetailDialogProductsSection;
